import React from "react";
import {
  Group,
  Text,
  UnstyledButton,
  createStyles,
  getStylesRef,
} from "@mantine/core";

import { IconSquarePlus } from "@tabler/icons-react";

import ClientIcon from "../../images/clientIcon.png";

const useStyles = createStyles((theme, {disabled}) => ({
  mybutton: {
    background: "#FFBA45",
    marginLeft: "8px",
    opacity: disabled ? 0.8 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
    borderRadius : '.5rem',
    [`&:hover .${getStylesRef("btnIcon")}`]: {
      background: "#eeaa33",
    },
  },
  bgColor:{
    background: "#fff !important",
  },
  
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "#FFBA45",
    borderRadius: 5,
  },
  btnText: {
    ref: getStylesRef("btnText"),
  },
}));

const AddButton = ({ title, BtnIcon , onClick, disabled , bgLess}) => {
  const { classes } = useStyles({disabled});
  let mainClass = bgLess ? [classes.mybutton , classes.bgColor] : classes.mybutton; 
  return (
    <UnstyledButton
      id="add-new-facility"
      className={mainClass}
      sx={{
        border: bgLess ? "1px solid #D0D5DD" : "none",
        [`&:hover .${getStylesRef("btnText")}`]: {
          background: bgLess ? '#fff' : "#eeaa33",
        },
      }}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
    >
      <Group spacing={5} p={10} sx={{display:'flex',alignItems:'center'}} >
        {/* {title === "Add Client" ? (
          <img
            src={ClientIcon}
            width={39}
            style={{ margin: "0 -4px", padding: "4px" }}
            className={classes.btnIcon}
            alt="client"
          />
        ) : (
          <IconSquarePlus
            color="black"
            stroke={1}
            className={classes.btnIcon}
            size={50}
          />
        )} */}
        <div>
          {BtnIcon ? BtnIcon : false}
        </div>
        
        <Text
          sx={{
            fontFamily: "Inter",
            fontSize: 16, 
            fontWeight: 500,
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
            backgroundColor: bgLess ? "#fff" : "#FFBA45",
          }}
          className={classes.btnText}
          // p={7}
          ml={0}
        >
          {title}
        </Text>
      </Group>
    </UnstyledButton>
  );
};

export default AddButton;
